module.exports = __webpack_public_path__ + "img/up-skool-logo.008c3d5f.png";